import { z } from 'zod'
import { BookingPreference } from '../../../../types/common'
import { normalizeDate, toNumberOrUndefined } from '../../../utils'

export const containerCollectionSchema = z
  .object({
    id: z.number().optional(),
    shipmentBookingId: z.number().optional(),
    loadTemplateId: z.number().min(1, { message: 'Load template is required' }),
    quantity: z.preprocess(
      toNumberOrUndefined,
      z
        .number()
        .int()
        .min(1, { message: 'Quantity is required' })
        .max(2147483647, { message: 'Max 2,147,483,647' })
    ),
    carrierId: z.number().optional(),
    locationId: z.number().optional(),
    croNumber: z.string().max(50, { message: 'Max 50 characters' }).optional(),
    croValidFrom: z.date().nullable().optional(),
    croValidTo: z.date().nullable().optional(),
    carrierOption: z.nativeEnum(BookingPreference).optional(),
    shippingLineId: z.number().optional(),
    specialInstructions: z.string().max(200, { message: 'Max 200 characters' }).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.carrierOption === BookingPreference.PreferredLine) {
      if (!data.carrierId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Shipping Line is required',
          path: ['carrierId'],
        })
      }
    } else if (data.carrierOption === BookingPreference.PreBooked) {
      if (!data.carrierId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Shipping Line is required',
          path: ['carrierId'],
        })
      }
      if (!data.croNumber) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'CRO Number is required',
          path: ['croNumber'],
        })
      }
      if (!data.croValidFrom) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Valid From date is required',
          path: ['croValidFrom'],
        })
      }
      if (!data.croValidTo) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Valid To date is required',
          path: ['croValidTo'],
        })
      }
      if (data.croValidTo) {
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        const validToDate = normalizeDate(data.croValidTo)
        if (validToDate < now) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Valid To date cannot be in the past',
            path: ['croValidTo'],
          })
        }
      }
      if (data.croValidFrom && data.croValidTo) {
        const validFromDate = normalizeDate(data.croValidFrom)
        const validToDate = normalizeDate(data.croValidTo)
        if (validFromDate >= validToDate) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Valid From date must be before Valid To date',
            path: ['croValidFrom'],
          })
        }
      }
      if (!data.locationId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Empty Collection Terminal is required',
          path: ['locationId'],
        })
      }
    }
  })

export type IContainerCollection = z.infer<typeof containerCollectionSchema>
